import styled from "@emotion/styled";

export const TimeLabel = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: var(--mb-color-filter);
  }
`;
